import { version } from "./version";

export const environment = {
  production: true,
  apiUrl: "https://mappa-dealer.herokuapp.com/api/v1",
  name: "production",
  version,
};
